/*
 * @FilePath: router.config.js
 * @Author: Aron
 * @Date: 2023-07-21 11:29:16
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-09-15 11:55:16
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
 */
import operateConfig from './operateConfig'
import financeConfig from './financeConfig'
import operateManageConfig from './operateManageConfig'
import noviceTasks from './noviceTasks'
import dataCenter from './dataCenter'
import saleCenter from './SaleCenterConfig'
import serviceCenter from './serviceCenterConfig'
import headTools from './headTools'
import agentProvider from './agentProviderConfig'
import inAndOut from './inAndOut'
import agentManage from './agentManage'
import channelAgents from './channelAgents'
import systemManage from './systemManage'
import cockpitManage from "./cockpitManage"
import pineconeBusiness from './pineconeBusiness'
import statisticalAnalysis from './statisticalAnalysis'

import ReferralManagement from './ReferralManagement'
export const routes = [
  {
    path: "/",
    name: "login",
    component: () => import("@/views/Login/login"),
    meta: {
      permission: false,
      allowBack: false,
      noCache: true,
	  title:"登录"
    }
  },
  {
    path: "/ssologin",
    name: "ssologin",
    component: () => import("@/views/SsoLogin/index"),
    meta: {
      permission: false,
      allowBack: false,
      noCache: true,
    }
  },
  {
    path: "Transfer",
    name: "Transfer",
    meta: {
      title: "等待跳转",
    },
    component: () =>import("@/views/Home/Transfer.vue")
  },
  {
    path: "/main",
    name: "home",
    component: () => import("@/views/Home/home"),
    meta: {
      permission: true,
      allowBack: false,
      noCache: true
    },
    children: [
      //运营中心
      ...operateConfig,
      //财务中心
      ...financeConfig,
      //运营管理
      ...operateManageConfig,
      //新手任务
      ...noviceTasks,
      // 数据中心
      ...dataCenter,
      //销售中心
      ...saleCenter,
      //服务中心
      ...serviceCenter,
      //总部工具集
      ...headTools,
      // 代理商供应商
      ...agentProvider,
      // 出入库管理
      ...inAndOut,
      // 代理商管理
      ...agentManage,
      // 渠道代理商
      ...channelAgents,
      // 系统管理
      ...systemManage,
      // 销售驾驶舱
      ...cockpitManage,
      // 松果业务
      ...pineconeBusiness,
      // 案例库
      ...ReferralManagement,
      // 统计分析
      ...statisticalAnalysis,
      // 其他
      {
        path: "ExportImportQuery",
        name: "ExportImportQuery",
        meta: {
          title: "导出导入"
        },
        component: () =>import("@/views/Home/AngentManage/ExportImportQuery/index")
      },
      {
        path: "NoPermission",
        name: "NoPermission",
        meta: {
          title: "无权限"
        },
        component: () => import("@/views/Home/NoPermission.vue")
      },
      {
        path: "NoMenu",
        name: "NoMenu",
        meta: {
          title: "无权限"
        },
        component: () =>import("@/views/Home/NoMenu.vue")
      }
    ],
  },
]
